<div id="wallet_container"></div>